export default __webpack_public_path__ + "static/media/nucleus.338ae0cb.jpeg";